export default __webpack_public_path__ + "static/media/ketoworkout_breakfast@2x.72734ef2.jpg";